import { render } from "./Tab2.vue?vue&type=template&id=25828cfc"
import script from "./Tab2.vue?vue&type=script&lang=ts"
export * from "./Tab2.vue?vue&type=script&lang=ts"
script.render = render

export default script